import { useQuery } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { ReportScheduleResponse } from "@/types";

type Props = {
  page: string | null;
  proceduresId: string;
  date_start: string;
  date_end: string;
  status: string;
  patientsId: string;
  employeesId: string;
  payment_history: string;
  per_page?: string | null;
};

async function fetchReportSchedule({
  page,
  proceduresId,
  date_start,
  date_end,
  status,
  patientsId,
  employeesId,
  payment_history,
  per_page
}: Props): Promise<ReportScheduleResponse> {
  const response = await httpRequest.get<ReportScheduleResponse>(
    `/report/schedulings?status=${status}&date_start=${date_start}&date_end=${date_end}&page=${page || 1}&employeesId=${employeesId}&patientsId=${patientsId}&proceduresId=${proceduresId}&payment_history=${payment_history}&per_page=${per_page || 10}`
  );
  return response.data;
}

export function useFetchReportSchedulesQuery({
  page,
  proceduresId,
  date_start,
  date_end,
  status,
  patientsId,
  employeesId,
  payment_history
}: Props) {
  const accountsResponseQuery = useQuery({
    queryKey: [
      "schedulings",
      page,
      proceduresId,
      date_start,
      date_end,
      status,
      patientsId,
      employeesId,
      payment_history
    ],
    queryFn: () =>
      fetchReportSchedule({
        page,
        proceduresId,
        date_start,
        date_end,
        status,
        patientsId,
        employeesId,
        payment_history
      }),
    keepPreviousData: false,
    enabled: !!patientsId,
  });

  return {
    ...accountsResponseQuery,
    data: accountsResponseQuery.data,
  };
}
